import { Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck } from "lucide-react";

import { PageHeader, Unavailable, PrivacyNote } from "../components/kit";

export function PlannedList({ items, testid = "member-planned-list" }) {
  return (
    <div>
      <h2 className="mb-2 text-base font-bold text-brand-purple">Was hier möglich sein wird</h2>
      <ul className="space-y-2" data-testid={testid}>
        {items.map((p) => (
          <li key={p} className="flex gap-2 text-brand-purple/85"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand-purple/50" aria-hidden="true" /> {p}</li>
        ))}
      </ul>
    </div>
  );
}

export function ViewBody({ view }) {
  return (
    <div className="space-y-5">
      <Unavailable />
      {view.planned && <PlannedList items={view.planned} />}
      {(view.rules || []).map((r) => <PrivacyNote key={r}>{r}</PrivacyNote>)}
      {view.links && (
        <div className="flex flex-wrap gap-2">
          {view.links.map((l) => (
            <Link key={l.to} to={l.to} className="inline-flex min-h-[44px] items-center rounded-xl border border-brand-purple/20 bg-white px-4 font-medium text-brand-purple hover:bg-brand-purple/5">{l.label}</Link>
          ))}
        </div>
      )}
    </div>
  );
}

// Protected view without Core endpoint: honest state, never a simulated success.
export default function UnavailableView({ view }) {
  return (
    <div className="max-w-3xl" data-testid="member-unavailable-view" data-m={view.m}>
      <PageHeader title={view.title} intro={view.intro} back={view.back} />
      <div className="rounded-2xl border border-brand-purple/10 bg-white p-5"><ViewBody view={view} /></div>
      <p className="mt-4 flex items-center gap-2 text-xs text-brand-purple/60"><ShieldCheck className="h-4 w-4" aria-hidden="true" /> Es werden keine Daten gespeichert oder an andere Personen gesendet.</p>
    </div>
  );
}
